import { render, staticRenderFns } from "./PasswordUpdate.vue?vue&type=template&id=5f4f1f33&scoped=true&"
import script from "./PasswordUpdate.vue?vue&type=script&lang=js&"
export * from "./PasswordUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4f1f33",
  null
  
)

export default component.exports